<div class="c-price-filter">
	<div class="c-price-filter__title">
		<p class="u-text--medium">
			{{ 'PRICE_FILTER.TITLE' | translate }}

			<button (click)="showInfo.set(true)" class="c-btn-link u-text--normal u-text--sm">Uitleg</button>
		</p>
	</div>

	@if (form) {
		<form [formGroup]="form">
			<p>&euro;</p>
			<tvcore-input name="min" type="number" [min]="0" [max]="maximum" (focusOut)="checkValues()"></tvcore-input>
			<p>{{ 'PRICE_FILTER.TO' | translate }}</p>
			<tvcore-input name="max" type="number" [min]="minimum" [max]="max" (focusOut)="checkValues()"></tvcore-input>
		</form>
	}
</div>

@if (type === OffersType.ACCOMMODATION) {
	<tvcore-dialog (close)="showInfo.set(false)" [title]="'PRICE_FILTER.ACCOMMODATION_DIALOG.TITLE' | translate" [visible]="showInfo()">
		<div [innerHTML]="'PRICE_FILTER.ACCOMMODATION_DIALOG.CONTENT' | translate"></div>
		<hr />
		<div [innerHTML]="'PRICE_FILTER.ACCOMMODATION_DIALOG.CONTENT_2' | translate"></div>
	</tvcore-dialog>
} @else if (type === OffersType.DAYTRIP) {
	<tvcore-dialog (close)="showInfo.set(false)" [title]="'PRICE_FILTER.DAYTRIP_DIALOG.TITLE' | translate" [visible]="showInfo()">
		<div [innerHTML]="'PRICE_FILTER.DAYTRIP_DIALOG.CONTENT' | translate"></div>
	</tvcore-dialog>
}
